export default {
  anyActive: state => !!state.activeId,
  isActive: (state, getters) => id => getters.anyActive && state.activeId === id,
  active: (state, getters) => getters.anyActive && getters.objectById(state.activeId),

  objectById: state => id => state.landing.find(l => l.id === id) || null,
  descendants: state => id => state.landing.filter(l => l.path && l.path.includes(id)) || [],

  pageCategory: state => state.pageCategory,

  pageType: state => state.pageType,

  currentNavBar: state => state.currentNavBar,

  containers: state => (types = ['Tabs', 'Section', 'HeroSparkBanner']) =>
    state.landing
      .filter(l => !l.path && types.includes(l.type))
      .sort((one, two) => one.options[state.currentView].position - two.options[state.currentView].position)
      .map(l => ({
        id: l.id,
        type: l.type,
        position: l.options[state.currentView].position,
        size: 12,
        title: l.title,
        children: l.children,
      })),

  panels: (state, getters) =>
    getters.anyActive &&
    ((getters.active || {}).children || [])
      .filter(c => c.startsWith('P-'))
      .map(c => getters.objectById(c))
      .sort((one, two) => one.options[state.currentView].position - two.options[state.currentView].position)
      .map(l => ({
        id: l.id,
        position: l.options[state.currentView].position,
        size: l.options[state.currentView].size,
        title: l.title,
        children: l.children,
        panels: l.children.filter(c => c.startsWith('P-')),
        widget: l.children.filter(c => c.startsWith('W-')),
      })),

  widget: (_state, getters) =>
    getters.anyActive && getters.active.type === 'Panel' && getters.active.children.length
      ? getters.objectById(getters.active.children.find(c => c.startsWith('W-')))
      : null,
}
